export class Municipality {
  clientId: number;
  public: {
    mainUrl: string;
    url: string;
    phone: number;
    fullName: string;
  };
  home: {
    name: string;
    mainPhoto: string;
  };
  name: string;
  logo: string;
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/Municipality.ts